export const stepperTheme = {
  colorScheme: {
    light: {
      stepNumber: {
        activeBackground: 'var(--p-primary-100)',
        activeBorderColor: 'var(--p-primary-600)',
        borderColor: 'var(--p-primary-100)',
      },
    },
    dark: {
      stepNumber: {
        activeBackground: 'var(--p-primary-700)',
        activeBorderColor: 'var(--p-primary-900)',
        borderColor: 'var(--p-primary-900)',
      },
    },
  },
};
